import { type UserState } from "./user-state.js";

export class API {
  constructor(public readonly basePath: string) {}

  getUserState(
    data: {
      tagId: string;
      userIdentifier: string;
      token: string;
      referralCode?: string;
    },
    options?: {
      reload?: boolean;
    },
  ): Promise<UserState | null> {
    let path = `/tags/${data.tagId}/users/${data.userIdentifier}/state`;
    if (data.referralCode) {
      path += `?ref=${encodeURIComponent(data.referralCode)}`;
    }

    return this.fetch(path, {
      headers: {
        Authorization: `Bearer ${data.token}`,
      },
      cache: options?.reload ? "reload" : undefined,
    });
  }

  private async fetch<T>(path: string, opts: RequestInit = {}): Promise<T> {
    const res = await fetch(`${this.basePath}/v1${path}`, opts);
    if (!res.ok) {
      throw new Error(`API request failed: ${res.status} ${res.statusText}`);
    }

    return res.json() as Promise<T>;
  }
}
